import { Injectable } from '@angular/core';
import { configURI } from '../../../shared/apiUrlConfig';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ParDashboardService {
  url = environment.configURI;
  load;
  private parVendorList = '/par/dashboard';
  private Clientdashboard = '/client/par/dashboard';
  // httpClientHeaderOptions = {
  //   headers: new HttpHeaders({
  //     // 'x-access-token': localStorage.getItem('Token'),
  //     'Cache-Control': 'no-cache',
  //     'Pragma': 'no-cache',
  //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
  //   })
  // };

  constructor(private httpClient: HttpClient, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
  }

  getParVendorDetails() {
    // this.httpClientHeaderOptions = {
    //   headers: new HttpHeaders({
    //     // 'x-access-token': localStorage.getItem('Token'),
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //   })
    // };
    //this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
    let role = parseInt(localStorage.getItem("RoleVal"))
    if(role === 8){
      return this.httpClient.get(`${this.url}${this.Clientdashboard}`).catch(this.userFriendlyMsgs.errorHandler);
    }
    else {
      return this.httpClient.get(`${this.url}${this.parVendorList}`).catch(this.userFriendlyMsgs.errorHandler);
    // return this.httpClient.get(`${this.url}${this.agentDetails}${agentId}`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/par-dashboard/par-dashboard.service.ts